module.exports = __webpack_public_path__ + "static/media/GoogleSlidesOptimized.55f70506.webp";